import "./Services.css";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Services({handleCloseNavigation}) {
  const navigate = useNavigate();
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1024);
  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 1024;
      setIsMobileView(isNowMobile);
      // Close all accordions when resizing to desktop view
      if (!isNowMobile) {
        setActiveAccordion(null);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleAccordion = (index) => {
    if (!isMobileView) return;
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const handleLinkClick = (e, path) => {
    e.stopPropagation();
    if (handleCloseNavigation) {
      handleCloseNavigation();
    }
    if (path) {
      navigate(path);
    }
  };

  // Helper function to render the arrow icon
  const renderArrowIcon = (index) => (
    <i 
      className={`fa-solid fa-angle-right ${isMobileView && activeAccordion === index ? 'active-accordion' : ''}`}
      style={{ 
        // float: 'right',
        // marginLeft: '8px',
        transition: 'transform 0.3s ease',
        // display: 'inline-block'
      }}
    ></i>
  );

  let accordionIndex = 0;
  return (
    <div className="services">
      <div className="section">
        {/* <div className="sec1 sec">
          <div className="sec1-1 secc">
            <h1>Made To <span>Scale</span></h1>
            <p>
            Leverage our software development expertise. We'll turn your ideas into powerful, scalable solutions
            </p>
            <img src="https://appinventiv.com/wp-content/themes/twentynineteen-child/new-images/ikea-drop-img.webp" alt="error" />
          </div>
          <div className="sec1-2">
            <p>Leading Technology Offerings For</p>
            <h5>Startup</h5>
            <h5>Public Entities</h5>
            <h5>Enterprises</h5>
          </div>
        </div> */}
        <div className="sec2 sec">
          <div className={`sec2-1 secc ${isMobileView && activeAccordion === accordionIndex ? 'active' : ''}`}
             onClick={() => {
              const currentIndex = 0;
              toggleAccordion(currentIndex);
            }}>
            <h4>Ideation And Product Design {renderArrowIcon(0)}</h4>
            <p><Link to='/ui-ux-service' onClick={handleCloseNavigation}>UI/UX</Link></p>
          </div>
          <div
          className={`sec2-2 secc ${isMobileView && activeAccordion === 1 ? 'active' : ''}`}
  onClick={() => {
    const currentIndex = 1;
    toggleAccordion(currentIndex);
  }}>
            <h4>Mobile app dev {renderArrowIcon(1)}</h4>
            <p>PWA</p>
            {/* <p><Link to='/progressive-web-app-services' onClick={handleCloseNavigation}>PWA</Link></p> */}
            <p><Link to='/mobile-app-development-services' onClick={handleCloseNavigation}>Mobile First Design</Link></p>
          </div>
          {/* <div className="sec2-3 secc">
            <h4>DIGITAL TRANSFORMATION</h4>
            <p>Supply chain management</p>
            <p>Legal modernization</p>
          </div>
          <div className="sec2-4 secc bottom">
            <h4>ELECTRIC VEHICLES</h4>
            <p>E-mobility</p>
          </div> */}
          <div 
          className={`secc bottom ${isMobileView && activeAccordion === 2 ? 'active' : ''}`}
          onClick={() => toggleAccordion(2)}>
            <h4>Artificial Intelligence {renderArrowIcon(2)}</h4>
            <p>Generative AI</p>
            <p>Computer Vision</p>
            <p>Machine Learning</p>
          </div>
        </div>
        <div className="sec3 sec">
          <div 
          className={`sec3-1 secc ${isMobileView && activeAccordion === 3 ? 'active' : ''}`}
          onClick={() => toggleAccordion(3)}>
            <h4>Software Development {renderArrowIcon(3)}</h4>
            <p><Link to='/website-development' onClick={handleCloseNavigation}>Website Development</Link></p>
             {/* Game Development */}
            <p><Link to='/game-development' onClick={handleCloseNavigation}>Game Development</Link></p>
            {/* <p>Blockchain Development</p> */}
            <p><Link to='/crm-development' onClick={handleCloseNavigation}>Custom CRM Development</Link></p>
             {/* <p>Custom CRM Development</p> */}
             <p><Link to='/ar-vr-development-services'  onClick={handleCloseNavigation}>AR/VR Development</Link></p>
            {/* <p>IoT Development</p>
            <p>Microservices</p> */}
            <p>Product Development</p>
          </div>
          <div 
           className={`sec3-2 secc bottom ${isMobileView && activeAccordion === 4 ? 'active' : ''}`}
           onClick={() => toggleAccordion(4)}>
            <h4>Cloud Services {renderArrowIcon(4)}</h4>
            <p>Cloud Managed Services</p>
            <p>Cloud Consulting</p>
          </div>
         
        </div>
        <div className="sec5 sec">
        
          <div 
          className={`sec4-2 secc ${isMobileView && activeAccordion === 5 ? 'active' : ''}`}
          onClick={() => toggleAccordion(5)}>
            <h4>IT Consulting {renderArrowIcon(5)}</h4>
            <p>Healthcare IT Consulting Services</p>
            <p>IT Outsourcing services</p>
          </div>
          <div 
          className={`sec4-1 secc ${isMobileView && activeAccordion === 6 ? 'active' : ''}`}
          onClick={() => toggleAccordion(6)}>
            <h4>Blockchain Services {renderArrowIcon(6)}</h4>
            <p>NFT Marketplace</p>
            <p>Metaverse Development</p>
            <p>Dapp Development</p>
          </div>
          <div 
           className={`sec3-3 secc bottom ${isMobileView && activeAccordion === 7 ? 'active' : ''}`}
           onClick={() => toggleAccordion(7)}>
            <h4> Analytics {renderArrowIcon(7)}</h4>
            {/* <p>Supply chain management</p> */}
            <p>Business Intelligence</p>
            <p>Data Analytics</p>
          </div>
        </div>
        <div className="sec4 sec">
        
          
          <div 
          className={`sec4-3 secc bottom ${isMobileView && activeAccordion === 8 ? 'active' : ''}`}
          onClick={() => toggleAccordion(8)}>
            <h4>DevOps {renderArrowIcon(8)}</h4>
            <p>Continuous Integration (CI)</p>
            <p>Continuous Delivery/Deployment (CD)</p>
            <p>Automation</p>
            <p>Configuration Management</p>
            <p>Monitoring & Observability</p>
            <p>Containerization</p>
            <p>Cloud Computing</p>
            <p>Scalability</p>
            <p>Orchestration</p>
            <p>Security & Compliance</p>

          </div>
          
        </div>
      </div>
    </div>
  );
}